import React from "react";
import axios from "axios";
import { NavLink } from "reactstrap";
import { Link } from "react-router-dom";
import paginationFactory, {
	PaginationProvider,
} from "react-bootstrap-table2-paginator";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBan, faEye } from "@fortawesome/free-solid-svg-icons";
import { Table } from "../../../components/CustomPaginations";
import {
	dateCol,
	ticketPriority,
	ticketStatus,
	tableStyle,
} from "../variables/ListingVariables";
import "../../stylesheets/resource.scss";
import { Resource_APIs } from "./Resource_APIs";
import { UserConsumer } from "../../../UserContext";
import Header from "../../timesheetModule/Header";
import Edit from "../../../images/edit.svg";
import Delete from "../../../images/delete.svg";
import { statusColor } from "../../../components/TableStyle";
import { AlertPopups } from "../../../components/AlertPopups";
import {
	GlobalPaginationSize,
	getPaginationSizeOnRole,
} from "../../../components/GlobalPaginationSize";
import { Routes } from "../../../configurations/config";
let token = null,
	userId = null;
let empDesignation = null;

class MyTickets extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			error: null,
			isLoaded: false,
			items: [],
			toggledClearRows: false,
			tableLoader: false,
			currentPage: 1,
			pageNum: 1,
			numberOfItemsPerPage: GlobalPaginationSize.defaultPaginationSize,
			pagerData: [],
			sortBy: { dataField: "ticketId", order: "desc" },
		};
		this.input = React.createRef();
	}
	getColumns = () => {
		return [
			{
				dataField: "ticketId",
				text: "Ticket ID",
				sort: true,
			},
			{
				dataField: "itemName",
				text: "Item Name",
				sort: true,
				formatter: (cell, row) => {
					if (row.itemName === null) {
						return row.alternateTicketItem;
					} else {
						return row.itemName;
					}
				},
				headerStyle: {
					width: "20%",
				},
			},
			{
				dataField: "department",
				text: "Assigned to",
				headerStyle: {
					width: "17%",
				},
			},
			{
				dataField: "priority",
				text: "Priority",
				formatter: ticketPriority,
			},
			{
				dataField: "status",
				text: "Status",
				formatter: ticketStatus,
				style: (cell, row) => {
					return statusColor(ticketStatus(row.status));
				},
			},
			{
				dataField: "expectedDate",
				text: "Due Date",
				sort: true,
				formatter: dateCol,
			},
			{
				dataField: "link",
				text: "Action",
				align: "right",
				events: {
					onClick: (e) => {
						e.stopPropagation(); // To stop navigation to detail screen
					},
				},
				formatter: (cell, row) => {
					return (
						<div className="navLinkClass">
							<Link
								className="tickeIdClass idHover align-self-end"
								to={{
									pathname: `${Routes.TicketDetails}/${row.ticketId}`,
									state: {
										currentPage: this.state.currentPage,
										redirectUrl: Routes.MyTickets,
									},
								}}
							>
								<button
									className="btnStyle"
									title="View Detail"
								>
									<FontAwesomeIcon
										id="edit"
										className="hoverEffect"
										icon={faEye}
										style={{
											height: "24px",
											width: "20px",
											cursor: "pointer",
										}}
									/>
								</button>
							</Link>
							{row.status === 0 ? (
								<Link
									to={{
										pathname: `${Routes.EditTicket}/${row.ticketId}`,
										state: {
											currentPage: this.state.currentPage,
											redirectUrl: Routes.MyTickets,
											itemStatus: ticketStatus(
												row.status
											),
										},
									}}
								>
									<img
										title="Edit"
										style={{
											height: "20px",
											width: "20px",
											marginLeft: "10px",
										}}
										src={Edit}
										alt="ohSnap"
									/>
								</Link>
							) : (
								<FontAwesomeIcon
									id="ban"
									icon={faBan}
									size="1x"
									style={{
										marginLeft: "10px",
									}}
								/>
							)}
							<NavLink
								onClick={(e) => {
									row.status === 0
										? this.deleteRecord(row.ticketId, e)
										: AlertPopups.WarningAlert.fire({
												text: "Ticket processed, cannot delete",
										  });
								}}
							>
								<img
									title="Delete"
									style={{
										height: "18px",
										width: "18px",
										cursor: "pointer",
									}}
									src={Delete}
									alt="ohSnap"
								/>
							</NavLink>
						</div>
					);
				},
				headerStyle: {
					width: "11%",
					textAlign: "center",
				},
			},
		];
	};
	componentDidMount() {
		const pageSize = getPaginationSizeOnRole(empDesignation);
		this.setState({
			numberOfItemsPerPage: pageSize,
		});

		const { history } = this.props;
		history && history.replace();
		const headers = {
			Authorization: `Bearer ${token}`,
		};
		this.setState({ tableLoader: true }, () => {
			axios
				.get(
					`${Resource_APIs.GetAllResourceTickets_API}${userId}&PageSize=${pageSize}&Page=${this.state.pageNum}&SortBy=${this.state.sortBy.dataField}_${this.state.sortBy.order}`,
					{
						headers: headers,
					}
				)
				.then((res) => {
					const items = res.data.ticketResponses;
					this.setState({
						items,
						tableLoader: !this.state.tableLoader,
						pagerData: JSON.parse(res.headers["x-pagination"]),
					});
				});
		});
	}
	deleteRecord = (id) => {
		const headers = {
			Authorization: `Bearer ${token}`,
		};

		AlertPopups.confirmBox
			.fire({
				text: "This ticket will no longer be available",
			})
			.then((result) => {
				if (result.value) {
					this.setState({ tableLoader: true }, () => {
						axios
							.delete(`${Resource_APIs.DeleteTicket_API}${id}`, {
								headers: headers,
							})
							.then((res) => {
								axios
									.get(
										`${Resource_APIs.GetAllResourceTickets_API}${userId}`,
										{
											headers: headers,
										}
									)
									.then((res) => {
										if (res.status === 200) {
											const items =
												res.data.ticketResponses;
											AlertPopups.InfoAlert.fire({
												text: "Ticket deleted",
											});
											this.setState({
												items,
												tableLoader:
													!this.state.tableLoader,
											});
										}
									});
							});
					});
				}
			});
	};
	SearchBar = () => {
		return (
			<div>
				<input
					className="form-control searchBar"
					ref={(n) => (this.input = n)}
					type="text"
					onChange={this.handleSearch}
					onFocus={() => this.setState({ currentPage: 1 })}
					placeholder="Search"
				/>
			</div>
		);
	};
	static getDerivedStateFromProps(nextProps, prevState) {
		return {
			currentPage:
				nextProps.history &&
				nextProps.history.location &&
				nextProps.history.location.state
					? nextProps.history.location.state.currentPage
					: prevState.currentPage,
		};
	}
	defaultSorted = [
		{
			dataField: "ticketId",
			order: "desc",
		},
	];
	receiveData = (PageSize) => {
		axios
			.get(
				`${
					Resource_APIs.GetAllResourceTickets_API
				}${userId}&PageSize=${PageSize}&Page=${1}&SortBy=${
					this.state.sortBy.dataField
				}_${this.state.sortBy.order}${
					this.input.value ? "&SearchTerm=" + this.input.value : ""
				}`,
				{
					headers: { Authorization: `Bearer ${token}` },
				}
			)
			.then((res) => {
				let items = res.data.ticketResponses;
				if (res.status === 200) {
					this.setState({
						pageNum: 1,
						numberOfItemsPerPage: PageSize,
						items: items,
						pagerData: JSON.parse(res.headers["x-pagination"]),
					});
				}
			});
	};
	handleTableChange = (type, { page, sortOrder, sortField }) => {
		let getData = false;
		let apiURL = "";

		if (type === "sort") {
			apiURL = `${
				Resource_APIs.GetAllResourceTickets_API
			}${userId}&PageSize=${
				this.state.numberOfItemsPerPage
			}&Page=${page}&SortBy=${sortField}_${sortOrder}${
				this.input.value ? "&SearchTerm=" + this.input.value : ""
			}`;
			getData = true;
			this.setState({
				sortBy: { dataField: sortField, order: sortOrder },
			});
		} else if (type === "pagination") {
			apiURL = `${
				Resource_APIs.GetAllResourceTickets_API
			}${userId}&PageSize=${
				this.state.numberOfItemsPerPage
			}&Page=${page}&SortBy=${sortField}_${sortOrder}${
				this.input.value ? "&SearchTerm=" + this.input.value : ""
			}`;
			getData = true;
		}
		if (getData) {
			axios
				.get(apiURL, {
					headers: { Authorization: `Bearer ${token}` },
				})
				.then((res) => {
					let items = res.data.ticketResponses;
					if (res.status === 200) {
						this.setState({
							pageNum: page,
							pagerData: JSON.parse(res.headers["x-pagination"]),
							items: items,
						});
					}
				});
		}
	};
	handleSearch = (event) => {
		const value = event.target?.value;
		axios
			.get(
				`${Resource_APIs.GetAllResourceTickets_API}${userId}&PageSize=${
					this.state.numberOfItemsPerPage
				}&Page=${1}&SortBy=${this.state.sortBy.dataField}_${
					this.state.sortBy.order
				}${value ? "&SearchTerm=" + value : ""}`,
				{
					headers: { Authorization: `Bearer ${token}` },
				}
			)
			.then((res) => {
				if (res.status === 200) {
					this.setState({
						pageNum: 1,
						pagerData: JSON.parse(res.headers["x-pagination"]),
						items: res.data.ticketResponses,
					});
				}
			});
	};
	render() {
		return (
			<UserConsumer>
				{(userDetails) => {
					token = userDetails.token;
					userId = userDetails.id;
					empDesignation = userDetails.designation;
					return (
						<>
							<div className="container-fluid pl-3 pr-3">
								<Header title="My Tickets" />
								<PaginationProvider
									pagination={paginationFactory({
										custom: true,
										totalSize: this.state.pagerData,
										page: this.state.pageNum,
										sizePerPage:
											this.state.numberOfItemsPerPage,
										paginationSize:
											this.state.numberOfItemsPerPage,
									})}
								>
									{({
										paginationProps,
										paginationTableProps,
									}) => {
										return (
											<Table
												columns={this.getColumns()}
												items={this.state.items}
												tableStyle={tableStyle}
												paginationProps={
													paginationProps
												}
												paginationTableProps={
													paginationTableProps
												}
												onTablePageChange={
													this.handleTableChange
												}
												defaultSorted={
													this.defaultSorted
												}
												tableLoader={
													this.state.tableLoader
												}
												SearchBar={this.SearchBar}
												inputValue={this.input.value}
												myTickets={true}
												keyField="ticketId"
												pagerData={this.state.pagerData}
												receiveData={(PageSize) => {
													this.receiveData(PageSize);
												}}
												rowEvents={{
													onClick: (e, row) => {
														this.props.history.push(
															{
																pathname: `${Routes.TicketDetails}/${row.ticketId}`,
																state: {
																	currentPage:
																		this
																			.state
																			.currentPage,
																	redirectUrl:
																		Routes.MyTickets,
																},
															}
														);
													},
												}}
											/>
										);
									}}
								</PaginationProvider>
							</div>
						</>
					);
				}}
			</UserConsumer>
		);
	}
}

export default MyTickets;
